import React from "react";

export const Header = () => {
    return <div className="header">Akulsoft - İstifadə qaydası</div>;
};
